import { createSelector } from 'reselect';
import { whatIfTypesDictionarySelector } from '../WhatIfsSelector';

export const appliedWhatIfsSelector = createSelector(
  whatIfTypesDictionarySelector,
  whatIfsDictionary => Object.keys(whatIfsDictionary).map((key) => {
    const whatIf = whatIfsDictionary[key];
    if (whatIf.IsApplied) {
      return {
        id: whatIf.WhatIf.WhatIfType,
        key: whatIf.WhatIf.WhatIfKey,
        question: whatIf.Title,
      };
    }
    return null;
  }).filter(whatIf => whatIf !== null),
);

export const numberOfEditsSelector = createSelector(
  appliedWhatIfsSelector,
  appliedWhatIfs => appliedWhatIfs.length,
);
